import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import React from "react";
import Draggable from "react-draggable";

const PaperComponent = (props) => {
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
};

export const AlertPopup = ({
    shouldDisplay,
    hasAgreedOrDismissed,
    title,
    displayMessage,
    actionText,
    cross,
    dismiss,
    level = "info",
    dropShadow = false,
}) => {
    /// This component requires work to make it a building block/generic to be used elsewhere.
    return shouldDisplay ? (
        <React.Fragment>
            <Dialog
                open={shouldDisplay}
                onClose={() => hasAgreedOrDismissed(true)}
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle
                    style={{ cursor: "move" }}
                    id="draggable-dialog-title"
                >
                    <Typography variant="body2" color="text.secondary">
                        {title}
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>{displayMessage}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        autoFocus
                        onClick={() => hasAgreedOrDismissed(true)}
                        variant="contained"
                    >
                        {actionText}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    ) : (
        ""
    );
};
